import * as io from 'socket.io-client';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { SessionStorageService } from '../session-storage.service';
import { environment } from '../../../environments/environment';
import { tap } from 'rxjs/operators';
import { IWrappedContractStateChangeMessage } from '../../helpers/socket-messages/contract-state-change-message';
import { SocketEvent } from './socket-event';
import { WebSocketIoBase } from './web-socket-io-base';

interface IWsLogoutMessage {
    socketId: string;
    room: string;
    message: string;
    timeoutS: number;
}

class WsLogoutMessage implements IWsLogoutMessage {
    message: string;
    room: string;
    socketId: string;
    timeoutS: number;
    get description(): string {
        return `Logout`;
    }

}

@Injectable()
export class WebSocketMessageService extends WebSocketIoBase implements OnDestroy {
    private readonly jwtSubscription: Subscription;
    // events configuration
    public readonly EVENTS = {
        CONTRACT_STATE_CHANGE: new SocketEvent('patavium.backend-api.contract-state-changes', new Subject<IWrappedContractStateChangeMessage>()),
    };

    constructor() {
        super();
        this.jwtSubscription = SessionStorageService.jwt.observable
            .pipe(tap(value => this.handleTokenChanges(value)))
            .subscribe();
    }

    protected get events(): SocketEvent<any>[] {
        return Object.values(this.EVENTS);
    }

    ngOnDestroy(): void {
        this.unsubscribeSioEvents();
        if (this.jwtSubscription != null) {
            this.jwtSubscription.unsubscribe();
        }
    }


    private handleTokenChanges(token: string): void {
        const tokenIsNull = token == null || token.length === 0;
        console.log(`The authentication token has changed.\n` +
            `New token is ${tokenIsNull ? 'null' : 'not null'}`);
        this.closeSocketConnection();
        if (!tokenIsNull) {
            this.openSocketConnection(token);
        }
    }

    private openSocketConnection(token: string) {
        const url: string = environment.socketUrl;
        const opts: SocketIOClient.ConnectOpts = {
            query: `auth_token=${token}`,
            transports: ['websocket'],
            upgrade: false,
            reconnection: true,
            reconnectionAttempts: 20,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 30000
        };
        this.openSocketConnectionInternal(url, opts);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/web-socket/web-socket-message.service.ts